webpackJsonp([8],{

/***/ "1K9X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_support_vue__ = __webpack_require__("G5/B");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c855e118_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_support_vue__ = __webpack_require__("hHuS");
function injectStyle (ssrContext) {
  __webpack_require__("UU3+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c855e118"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_support_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c855e118_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_support_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "BO1k":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("fxRn"), __esModule: true };

/***/ }),

/***/ "G5/B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_is_js__ = __webpack_require__("oQbg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_is_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_is_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_services_js__ = __webpack_require__("TZir");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_cookie__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'support',
  data: function data() {
    return {
      thanks: false,
      is: __WEBPACK_IMPORTED_MODULE_2_is_js___default.a,
      alert: new Date() < new Date(2021, 3, 9, 9, 0),
      questions: {
        main: {
          functionality: 'RememBear doesn\'t work properly',
          subscription: 'I\'m having an issue with my subscription or payment',
          account: 'I\'m having an issue with my RememBear account',
          feedback: 'I have general feedback or a feature request',
          question: 'I have a general question about RememBear'
        },
        functionality: {
          installation: 'I\'m having trouble installing RememBear',
          using: 'I\'m having trouble using RememBear',
          crashing: 'The RememBear app is crashing'
        },
        subscription: {
          upgrade: 'I want to upgrade my account',
          cancel: 'I want to cancel my account',
          billing: 'There\'s been a billing error'
        },
        account: {
          creation: 'I\'m having trouble creating my account',
          access: 'I\'m having trouble accessing my account',
          delete: 'I want to delete my account'
        },
        feedback: {
          request: 'I have a feature request',
          feedback: 'I have some feedback for the Bears'
        },
        platform: {
          windows: 'Windows',
          mac: 'macOS',
          android: 'Android',
          ios: 'iOS',
          browser: 'Browser extension'
        }
      },
      main: '',
      issue: {
        problem: '',
        platform: [],
        description: '',
        email: ''
      },
      submitted: false,
      submitting: false,
      submitError: '',
      showWarning: false,
      loggedInEmail: ''
    };
  },

  beforeMount: function beforeMount() {
    var _this = this;

    if (this.$store.getters.isLoggedIn) {
      this.$store.dispatch('prepareUserData').then(function (response) {
        _this.loggedInEmail = _this.$store.getters.userData.email;
      });
    }
  },
  computed: {
    phase: function phase() {
      var phase = this.issue.problem || this.main === 'question' ? 2 : 1;
      return phase;
    },
    errors: function errors() {
      var errors = [];
      if (!this.issue.platform && this.main === 'functionality') {
        errors.push('platform');
      }
      if (!this.issue.problem && this.main !== 'question') {
        errors.push('problem');
      }
      if (!this.issue.description || this.issue.description.length < 10) {
        errors.push('description');
      }
      var email = this.loggedInEmail || this.issue.email;
      if (!email || __WEBPACK_IMPORTED_MODULE_2_is_js___default.a.not.email(email)) {
        errors.push('email');
      }
      return errors;
    },
    currentError: function currentError() {
      if (!this.submitted) return '';
      var currentError = '';
      if (this.errors.length > 0) {
        currentError = this.errors[0];
      }
      return currentError;
    }
  },
  methods: {
    gatherInfo: function gatherInfo() {
      var info = [];
      info.push('How can we help?: ' + this.questions.main[this.main]);
      if (this.main !== 'question') {
        info.push('Whats the problem?: ' + this.questions[this.main][this.issue.problem]);
      }
      if (this.issue.platform.length > 0) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.issue.platform), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var platform = _step.value;

            info.push('Which platforms are affected?: ' + platform);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      info.sort();
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(info);
    },
    makeRequest: function makeRequest() {
      var _this2 = this;

      if (this.submitting) return;
      this.submitting = true;
      var data = {
        title: this.issue.description.substr(0, 49),
        message: this.issue.description,
        additionalInfo: this.gatherInfo(),
        fromAddress: this.loggedInEmail || this.issue.email
      };

      this.$http.post(this.ENV.apiBaseUrl + '/support/feedback', data, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        var time = new Date();
        time.setTime(time.getTime() + 1 * 3600 * 1000);
        __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.set('supportSpam', true, { expires: time });
        _this2.thanks = true;
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        _this2.submitting = false;
      }).catch(function (error) {
        if (error) {
          _this2.submitError = 'Whoops... something went wrong with your request. Please refresh and try again.';
          _this2.submitting = false;
        }
      });
    },
    resetForm: function resetForm() {
      this.submitted = false;
      this.issue = {
        problem: '',
        platform: [],
        description: '',
        email: ''
      };
    },
    resetOptions: function resetOptions() {
      this.issue.problem = '';
      this.issue.platform = [];
    },
    submit: function submit() {
      this.submitError = '';
      this.submitted = true;
      if (this.errors.length === 0) {
        if (__WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get('supportSpam')) {
          this.submitError = 'Oops, you\'ve already sent a request in the last hour.';
        } else {
          this.makeRequest();
        }
      }
    }
  },
  watch: {
    main: function main() {
      this.resetForm();
      this.submitError = '';
    }
  }
});

/***/ }),

/***/ "T/p7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/supportbear.ae7fb86.png";

/***/ }),

/***/ "UU3+":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("aafK");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("0b2f9bb2", content, true);

/***/ }),

/***/ "aafK":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, ".section-inner>.container[data-v-c855e118]{max-width:850px;margin:0 auto}.support-bear[data-v-c855e118]{max-width:164px;margin:0 auto 40px}.questions[data-v-c855e118]{margin-top:40px}.question-block[data-v-c855e118]{margin-bottom:20px}.view-inner[data-v-c855e118]{min-height:80vh}.count[data-v-c855e118]{float:right;margin-top:5px}", "", {"version":3,"sources":["/opt/build/repo/src/views/support/support.styl"],"names":[],"mappings":"AACA,2CACE,gBAAiB,AACjB,aAAe,CAChB,AACD,+BACE,gBAAiB,AACjB,kBAAoB,CACrB,AACD,4BACE,eAAiB,CAClB,AACD,iCACE,kBAAoB,CACrB,AACD,6BACE,eAAiB,CAClB,AACD,wBACE,YAAa,AACb,cAAgB,CACjB","file":"support.styl","sourcesContent":["\n.section-inner > .container[data-v-c855e118] {\n  max-width: 850px;\n  margin: 0 auto;\n}\n.support-bear[data-v-c855e118] {\n  max-width: 164px;\n  margin: 0 auto 40px;\n}\n.questions[data-v-c855e118] {\n  margin-top: 40px;\n}\n.question-block[data-v-c855e118] {\n  margin-bottom: 20px;\n}\n.view-inner[data-v-c855e118] {\n  min-height: 80vh;\n}\n.count[data-v-c855e118] {\n  float: right;\n  margin-top: 5px;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "fxRn":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("+tPU");
__webpack_require__("zQR9");
module.exports = __webpack_require__("g8Ux");


/***/ }),

/***/ "g8Ux":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("77Pl");
var get = __webpack_require__("3fs2");
module.exports = __webpack_require__("FeBl").getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ "hHuS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-wrap"},[_c('section',{staticClass:"bg-regular view-inner"},[_c('div',{staticClass:"section-inner"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-8 col-md-9"},[(_vm.alert)?_c('p',{staticClass:"alert alert-warning"},[_vm._v("\n              Our scheduled RememBear maintenance has been completed and we're continuing to monitor things on our end. If you're having trouble syncing, try locking and unlocking RememBear. If issues persist, let us know by filling out this form to submit a ticket.\n            ")]):_vm._e(),_vm._v(" "),_c('h1',{staticClass:"h3"},[_vm._v("Contact a Support Bear")]),_vm._v(" "),_vm._m(1),_vm._v(" "),(_vm.thanks)?_c('div',[_vm._m(2),_vm._v(" "),_c('p',[_vm._v("A support bear will be in touch shortly. We do our best to respond to all tickets within 48 hours. Please be aware that following up multiple times before we have the chance to reply can delay us in getting to your initial message.")]),_vm._v(" "),_c('p',[_vm._v("While you wait, check out our "),_c('a',{attrs:{"href":_vm.external.help}},[_vm._v("help section")]),_vm._v(".")])]):_vm._e()])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-sm-4 col-md-3 support-bear"},[_c('img',{attrs:{"src":__webpack_require__("T/p7"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Our Bears are having some trouble receiving support ticket submissions right now. If you'd like to get in touch, please email us directly at "),_c('a',{attrs:{"href":"mailto:support@remembear.com"}},[_vm._v("support@remembear.com")]),_vm._v(" and we'll do our best to get back to you within 72 hours.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Rawr! We’ve received your message.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/8.69aca5266f03e8fc36cf.js